package com.eladfinish.bible.contest.screens.openQuestions.usecases

import com.eladfinish.bible.contest.screens.openQuestions.api.GoogleDriveApi
import com.eladfinish.bible.contest.utils.Sheet

class GetGoogleDriveDataUseCase(
    private val googleDriveApi: GoogleDriveApi,
) {

    suspend operator fun invoke(
        sheetId: String,
        sheetNumber: Int,
        format: String,
    ): Result<Sheet?> =
        googleDriveApi.getDataFromSpreadsheet(sheetId, sheetNumber, format)

}
